export const formatCompanyName = (name) => {
  if (!name) return '';

  const replacements = {
    'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ': 'ООО',
    'АКЦИОНЕРНОЕ ОБЩЕСТВО': 'АО',
    'ПУБЛИЧНОЕ АКЦИОНЕРНОЕ ОБЩЕСТВО': 'ПАО',
    'ЗАКРЫТОЕ АКЦИОНЕРНОЕ ОБЩЕСТВО': 'ЗАО',
    'ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ': 'ИП',
  };

  const regex = new RegExp(Object.keys(replacements).join('|'), 'gi');

  let formattedName = name.replace(regex, (match) => {
    return replacements[match.toUpperCase()] || match;
  });

  // Обрабатываем формат "ИП Фамилия Имя Отчество"
  if (formattedName.startsWith('ИП')) {
    formattedName = formattedName.replace(
      /ИП\s+(\S+)\s+(\S)\S*\s+(\S)\S*/i,
      'ИП $1 $2.$3.'
    );
  }

  formattedName = formattedName.replace(/\s*"\s*(.*?)\s*"\s*/g, ' "$1"');

  return formattedName.trim();
};
